import { Skeleton } from '@nextui-org/react'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import CollectionPreviewForSlider from '../collectionpreview/CollectionPreviewForSlider'

export const CategorySlider = ({ category }) => {
    const { t } = useTranslation('common')

    const swiperElRef = useRef(null)
    const [isDragging, setIsDragging] = useState(false)

    return (
        <div className={'max-w-full relative mb-4'}>
            <div className={' w-full h-auto gap-8 mx-2 md:mx-8'}>
                <button className="prev-button !bg-primary !rounded-full !p-2 absolute left-0 z-[9999] top-[140px]">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="3"
                        stroke="currentColor"
                        className="w-6 h-6  "
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M15.75 19.5 8.25 12l7.5-7.5"
                        />
                    </svg>
                </button>

                <button className="next-button !bg-primary !rounded-full !p-2 absolute right-0 z-[9999] top-[140px]">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="3"
                        stroke="currentColor"
                        className="w-6 h-6  "
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m8.25 4.5 7.5 7.5-7.5 7.5"
                        />
                    </svg>
                </button>
                <swiper-container
                    ref={swiperElRef}
                    space-between="20"
                    slides-per-view="auto"
                    navigation="true"
                    pagination="false"
                    navigation-next-el=".next-button"
                    navigation-prev-el=".prev-button"
                >
                    {category.collections ? (
                        category.collections
                            .slice(0, 24)
                            .map((collection, index) => (
                                <swiper-slide>
                                    <CollectionPreviewForSlider
                                        key={
                                            collection.collection + '_' + index
                                        }
                                        collection={collection}
                                        isBeingDragged={isDragging}
                                        category={category.key}
                                        customHref={category.customHref}
                                        customVolumeDisplay={
                                            category.customVolumeDisplay
                                        }
                                    />
                                </swiper-slide>
                            ))
                    ) : (
                        <div className="flex space-x-6">
                            {Array.from(new Array(24)).map(() => (
                                <Skeleton className="min-w-[224px] h-[328px] rounded-lg">
                                    <div className="h-24 rounded-lg bg-default-300"></div>
                                </Skeleton>
                            ))}
                        </div>
                    )}
                </swiper-container>
            </div>
        </div>
    )
}
